interface PlanInfo {
  planName: string | null
  status: string | null
  earlyAccess?: boolean
}

export const getCompactStatusText = (status: string | null): string => {
  if (!status) return ''

  const statusMap: Record<string, string> = {
    active: 'Active',
    trialing: 'Trial',
    past_due: 'Past Due',
    canceled: 'Canceled',
  }

  return statusMap[status] ?? status
}

export const formatPlanDisplay = (planInfo: PlanInfo | null | undefined): string => {
  if (!planInfo) {
    return 'Free'
  }

  const planName = planInfo.planName ?? 'Free'

  if (planInfo.earlyAccess) {
    return `${planName} • Early Access`
  }

  const statusText = getCompactStatusText(planInfo.status)

  if (statusText && planInfo.planName) {
    return `${planName} • ${statusText}`
  }

  return planName
}

export const getInitials = (name: string): string =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
